import { Category } from '../services/adminService'
// import { formatDate } from '../utils/dateUtils'
import { Table, TableColumn } from './Table'
import { Switch } from './ui/Switch'
import { useTranslation } from '../i18n/hooks/useTranslation'
import { Button } from './ui/Button'

interface CategoryListProps {
  categories: Category[]
  onEdit: (category: Category) => void
  onTranslations: (categoryId: string) => void
  onToggleStatus: (category: Category) => void
  togglingCategoryId?: string | null
}

export function CategoryList({ categories, onEdit, onToggleStatus, togglingCategoryId }: CategoryListProps) {
  const { t } = useTranslation()
  
  // const getStatusBadge = (status: string) => {
  //   const styles = {
  //     active: 'bg-green-100 text-green-800',
  //     inactive: 'bg-gray-100 text-gray-800',
  //   }
  //   return (
  //     <span className={`px-2 py-1 text-xs font-medium rounded-full ${styles[status as keyof typeof styles] || styles.active}`}>
  //       {t(`common.${status}`)}
  //     </span>
  //   )
  // }

  // Status options for filter
  const statusOptions = [
    { value: 'active', label: t('common.active') },
    { value: 'inactive', label: t('common.inactive') }
  ]

  const columns: TableColumn<Category>[] = [
    {
      key: 'status',
      header: t('common.status'),
      sortKey: 'status',
      sortable: true,
      className: 'w-40',
      filterable: {
        type: 'select',
        options: statusOptions,
        filterKey: 'status'
      },
      render: (category: Category) => (
        <Switch
          key={`switch-${category.id}`}
          checked={category.status === 'active'}
          onChange={() => onToggleStatus(category)}
          disabled={togglingCategoryId === category.id}
          size="sm"
        />
      )
    },
    {
      key: 'category',
      header: t('categories.title').slice(0, -1),
      sortKey: 'name',
      sortable: true,
      filterable: {
        type: 'text',
        placeholder: t('filters.filterBy.name'),
        filterKey: 'name'
      },
      render: (category: Category) => (
        <div className="flex items-center">
          <span className="text-lg mr-3">{category.icon}</span>
          <div>
            <div className="text-sm text-gray-900">
              {category.name || category.id}
            </div>
            {category.description && (
              <div className="text-sm text-gray-500">
                {category.description}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      key: 'order',
      header: t('categories.fields.order'),
      sortKey: 'order',
      sortable: true,
      className: 'w-20',
      filterable: {
        type: 'text',
        placeholder: t('filters.filterBy.order'),
        filterKey: 'order'
      },
      render: (category: Category) => (
        <span className="text-sm text-gray-900">
          {category.order}
        </span>
      )
    },

    {
      key: 'actions',
      header: t('common.actions'),
      className: 'text-right w-32',
      filterable: {
        type: 'none'
      },
      render: (category: Category) => (
        <div className="flex space-x-2">
          <Button
            onClick={() => onEdit(category)}
            variant="primary"
            size="sm"
          >
            {t('common.edit')}
          </Button>
        </div>
      )
    }
  ]

  return (
            <Table
      data={categories}
      columns={columns}
      searchableFields={['name', 'description']}
      searchPlaceholder={t('categories.searchPlaceholder')}
      emptyMessage="No categories found"
      emptySubMessage="Try adjusting your search or create your first category"
      pageSize={10}
      t={t}
    />
  )
} 